export default __webpack_public_path__ + "static/media/Effortless ScalabilityRight.c8671da6.png";